export enum TrainingValidation {
	AtleastOneParticipant,
	UniqueEmailParticipant,
	ValidAddressOwnLocation,
	ValidPreferredStartDate,
	ValidPriceCalculation,
	MaxParticipants,
	ValidVdiChoice,
}
